"use client";

import { c as _c } from "react/compiler-runtime";
import { useQueryState } from "nuqs";
export function useSearchqueryState() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      limitUrlUpdates: {
        method: "debounce",
        timeMs: 300
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const queryState = useQueryState("search", t0);
  return queryState;
}